import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=53ddcb46&scoped=true"
import script from "./robot.vue?vue&type=script&lang=ts"
export * from "./robot.vue?vue&type=script&lang=ts"
import style0 from "./robot.vue?vue&type=style&index=0&id=53ddcb46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ddcb46",
  null
  
)

export default component.exports